import { formatDateDisplay, numeralCustom } from "./helpers";
import FilterCRThuoc from "../components/common/filter/group/crthuoc/FilterCRThuoc";
import { CategoryType } from "../types/category.type";
import FormCRThuoc from "../components/common/form/crthuoc/FormCRThuoc";
import FilterCRHC from "../components/common/filter/group/crhc/FilterCRHC";
import FormCRVTYT from "../components/common/form/crvtyt/FormCRVTYT";
import FilterCRVTYT from "../components/common/filter/group/crvtyt/FilterCRVTYT";
import { TableColumn } from "react-data-table-component";
import { Box, Button, Stack, Tooltip, Typography, Zoom } from "@mui/material";
import ModalDetailId from "../components/common/modal/ModalDetailId";
import { groups } from "./group";
import DeleteGroupButton from "../components/common/button/DeleteGroupButton";
import CheckboxUpdate from "../components/common/fast-update/CheckboxUpdate";
import ExpandUsergroup from "../components/common/expand/usergroup/ExpandUsergroup";
import FormUsergroup from "../components/common/form/usergroup/FormUsergroup";
import FilterUsergroup from "../components/common/filter/usergroup/FilterUsergroup";
import FormParticipant from "../components/common/form/participant/FormParticipant";
import FilterParticipant from "../components/common/filter/group/participant/FilterParticipant";
import ResetPassword from "../components/common/fast-update/ResetPassword";
import FormDTTHUOC from "../components/common/form/dtthuoc/FormDTTHUOC";
import FormNCSDTHUOC from "../components/common/form/ncsdthuoc/FormNCSDTHUOC";
import FilterNCSDThuoc from "../components/common/filter/group/ncsdthuoc/FilterNCSDThuoc";
import FilterDTThuoc from "../components/common/filter/group/dtthuoc/FilterDTThuoc";
import { COLORS } from "./ui.constants";
import ExportToExcelButton from "../components/common/button/ExportToExcelButton";
import FilterRPKEYSEARCH from "../components/common/filter/group/rpkeysearch/FilterRPKEYSEARCH";
import FormIDThuoc from "../components/common/form/idthuoc/FormIDThuoc";
import FilterIDThuoc from "../components/common/filter/group/idthuoc/FilterIDThuoc";

type ItemType = keyof typeof COLORS;
const values: ItemType[] = ["max", "min", "near"];

const cols = values
  .map((item) => {
    return [
      {
        name: "ID (BV)",
        width: "120px",
        reorder: true,
        style: { color: COLORS[item] },
        selector: (row) => row[`${item}_id`],
      },
      {
        name: "Tên thuốc",
        width: "150px",
        style: { color: COLORS[item] },
        selector: (row) => row[`${item}_ten_thuoc`],
      },
      {
        name: "Tên hoạt chất",
        width: "200px",
        style: { color: COLORS[item] },
        selector: (row) => row[`${item}_hoat_chat`],
      },
      {
        name: "Hàm lượng",
        width: "120px",
        style: { color: COLORS[item] },
        selector: (row) => row[`${item}_hamluong`],
      },
      {
        name: "GĐKLH hoặc GPNK",
        width: "180px",
        style: { color: COLORS[item] },
        selector: (row) => row[`${item}_gdklh`],
      },
      {
        name: "Đường dùng",
        width: "140px",
        style: { color: COLORS[item] },
        selector: (row) => row[`${item}_duongdung`],
      },
      {
        name: "Dạng bào chế",
        width: "150px",
        style: { color: COLORS[item] },
        selector: (row) => row[`${item}_baoche`],
      },
      {
        name: "Đơn giá",
        width: "150px",
        right: true,
        style: { color: COLORS[item] },
        selector: (row) => row[`${item}_dongia`],
        format: (row) =>
          row[`${item}_dongia`]
            ? numeralCustom(row[`${item}_dongia`]).format()
            : "Chưa xác định",
      },
      {
        name: "Nhóm thuốc",
        width: "140px",
        style: { color: COLORS[item] },
        selector: (row) => row[`${item}_nhomthuoc`],
      },
      {
        name: "Tên CĐT",
        width: "150px",
        style: { color: COLORS[item] },
        selector: (row) => row[`${item}_cdt`],
      },
      {
        name: "Ngày ban hành QĐ",
        width: "200px",
        style: { color: COLORS[item] },
        selector: (row) => row[`${item}_ngayquyetdinh`],
        format: (row) =>
          formatDateDisplay(row[`${item}_ngayquyetdinh`], "DD/MM/YYYY"),
      },
    ] as TableColumn<any>[];
  })
  .reduce((acc: any[], item: any) => {
    return [...acc, ...item];
  }, []);

const categories: { [key: string]: CategoryType } = {
  cr_thuoc: {
    title: "Thuốc",
    apiCode: "cr_thuoc",
    allowCreate: true,
    showOptions: true,
    showActions: true,
    selectableRows: true,
    allowFilter: true,
    stringifyData: true,
    sortServer: true,
    Filter: FilterCRThuoc,
    Form: FormCRThuoc,
    fields: [
      { label: "Tên thuốc", value: "ten_thuoc" },
      { label: "Tên hoạt chất", value: "hoat_chat" },
      { label: "Hàm lượng", value: "hamluong" },
      { label: "GĐKLH hoặc GPNK", value: "gdklh" },
      // { label: "Đường dùng", value: "duongdung" },
      // { label: "Dạng bào chế", value: "baoche" },
      // { label: "Nhóm thuốc", value: "nhomthuoc" },
      // { label: "Cơ sở sản xuất", value: "cssx" },
      // { label: "Nước sản xuất", value: "nuocsx" },
      // { label: "Quy cách", value: "quycach" },
      // { label: "Đơn vị tính", value: "dvt" },
      { label: "Đơn giá", value: "dongia" },
      { label: "Mã TBMT", value: "tbmt" },
      // { label: "Tên CĐT", value: "cdt" },
      { label: "Ngày đăng tải KQLCNT", value: "ngay_kqlcnt" },
      // { label: "Số quyết định", value: "soquyetdinh" },
      { label: "Ngày quyết định", value: "ngayquyetdinh" },
      // { label: "Số nhà thầu tham dự", value: "slnhathau" },
      // { label: "Địa điểm", value: "diadiem" },
    ],
    fastFields: [
      { label: "Tên thuốc", value: "ten_thuoc" },
      { label: "Tên hoạt chất", value: "hoat_chat" },
      { label: "Địa điểm", value: "diadiem" },
      { label: "Đường dùng", value: "duongdung" },
      { label: "Dạng bào chế", value: "baoche" },
      { label: "Nhóm thuốc", value: "nhomthuoc" },
      { label: "Cơ sở sản xuất", value: "cssx" },
      { label: "Nước sản xuất", value: "nuocsx" },
      { label: "Quy cách", value: "quycach" },
      { label: "Đơn vị tính", value: "dvt" },
    ],
    columns: [
      {
        name: "ID (BV)",
        width: "120px",
        reorder: true,
        selector: (row) => row.id,
      },
      {
        name: "Tên thuốc",
        width: "150px",
        reorder: true,
        selector: (row) => row.ten_thuoc,
      },
      {
        name: "Đơn giá",
        width: "150px",
        reorder: true,
        sortable: true,
        sortField: "dongia",
        right: true,
        selector: (row) => row.dongia,
        format: (row) =>
          row.dongia ? numeralCustom(row.dongia).format() : "Chưa xác định",
      },
      {
        name: "Tên hoạt chất",
        width: "200px",
        reorder: true,
        selector: (row) => row.hoat_chat,
      },
      {
        name: "Hàm lượng",
        width: "150px",
        reorder: true,
        selector: (row) => row.hamluong,
      },
      {
        name: "GĐKLH hoặc GPNK",
        width: "180px",
        reorder: true,
        selector: (row) => row.gdklh,
      },
      {
        name: "Đường dùng",
        width: "140px",
        reorder: true,
        selector: (row) => row.duongdung,
      },
      {
        name: "Dạng bào chế",
        width: "150px",
        reorder: true,
        selector: (row) => row.baoche,
      },
      {
        name: "Nhóm thuốc",
        width: "140px",
        reorder: true,
        selector: (row) => row.nhomthuoc,
      },
      {
        name: "Cơ sở SX",
        width: "150px",
        reorder: true,
        selector: (row) => row.cssx,
      },
      {
        name: "Nước SX",
        width: "140px",
        reorder: true,
        selector: (row) => row.nuocsx,
      },
      {
        name: "Quy cách",
        width: "120px",
        reorder: true,
        selector: (row) => row.quycach,
      },
      {
        name: "ĐVT",
        width: "120px",
        reorder: true,
        selector: (row) => row.dvt,
      },
      {
        name: "Hình thức LCNT",
        width: "150px",
        reorder: true,
        selector: (row) => row.hinh_thuc_lcnt,
      },
      {
        name: "Hạn dùng",
        width: "150px",
        reorder: true,
        selector: (row) => row.han_dung,
      },
      {
        name: "Số lượng",
        width: "120px",
        reorder: true,
        right: true,
        selector: (row) => row.soluong,
      },
      {
        name: "Mã TBMT",
        width: "120px",
        reorder: true,
        selector: (row) => row.tbmt,
      },
      {
        name: "Tên CĐT",
        width: "120px",
        reorder: true,
        selector: (row) => row.cdt,
      },
      {
        name: "Ngày đăng tải KQLCNT",
        width: "210px",
        reorder: true,
        sortable: true,
        sortField: "ngay_kqlcnt",
        selector: (row) => row.ngay_kqlcnt,
        format: (row) => formatDateDisplay(row.ngay_kqlcnt, "DD/MM/YYYY"),
      },
      {
        name: "Số QĐ",
        width: "140px",
        reorder: true,
        selector: (row) => row.soquyetdinh,
      },
      {
        name: "Ngày ban hành QĐ",
        width: "200px",
        reorder: true,
        sortable: true,
        sortField: "ngayquyetdinh",
        selector: (row) => row.ngayquyetdinh,
        format: (row) => formatDateDisplay(row.ngayquyetdinh, "DD/MM/YYYY"),
      },
      {
        name: "Nhà thầu tham dự",
        width: "180px",
        reorder: true,
        selector: (row) => row.slnhathau,
        format: (row) => numeralCustom(row.slnhathau).format(),
      },
      {
        name: "Địa điểm",
        width: "200px",
        reorder: true,
        selector: (row) => row.diadiem,
      },
    ],
  },
  danhmucidthuoc: {
    title: "ID Thuốc",
    apiCode: "danhmucidthuoc",
    allowCreate: true,
    showOptions: true,
    showActions: true,
    selectableRows: true,
    allowFilter: true,
    stringifyData: true,
    Filter: FilterIDThuoc,
    Form: FormIDThuoc,
    fields: [
      { label: "ID", value: "id" },
      { label: "Tên mời thầu", value: "ten_moi_thau" },
      { label: "Hàm lượng", value: "ham_luong" },
      { label: "Dạng bào chế", value: "bao_che" },
      { label: "Đường dùng", value: "duong_dung" },
      { label: "Đơn vị tính", value: "don_vi" },
      { label: "Nhóm thuốc", value: "nhom" },
    ],
    fastFields: [
      { label: "ID", value: "id" },
      { label: "Tên mời thầu", value: "ten_moi_thau" },
      { label: "Hàm lượng", value: "ham_luong" },
      { label: "Dạng bào chế", value: "bao_che" },
      { label: "Đường dùng", value: "duong_dung" },
      { label: "Đơn vị tính", value: "don_vi" },
      { label: "Nhóm thuốc", value: "nhom" },
    ],
    columns: [
      {
        name: "ID (BV)",
        width: "120px",
        reorder: true,
        selector: (row) => row.id,
      },
      {
        name: "Tên mời thầu",
        width: "150px",
        reorder: true,
        selector: (row) => row.ten_moi_thau,
      },
      {
        name: "Hàm lượng",
        width: "150px",
        reorder: true,
        selector: (row) => row.ham_luong,
      },
      {
        name: "Dạng bào chế",
        width: "150px",
        reorder: true,
        selector: (row) => row.bao_che,
      },
      {
        name: "Đường dùng",
        width: "150px",
        reorder: true,
        selector: (row) => row.duong_dung,
      },
      {
        name: "Đơn vị tính",
        width: "140px",
        reorder: true,
        selector: (row) => row.don_vi,
      },
      {
        name: "Nhóm thuốc",
        width: "140px",
        reorder: true,
        selector: (row) => row.nhom,
      },
    ],
  },
  ncsdthuoc: {
    title: "Nhu cầu sử dụng thuốc",
    apiCode: "ncsdthuoc2",
    allowCreate: true,
    showOptions: true,
    showActions: true,
    selectableRows: true,
    allowFilter: true,
    stringifyData: true,
    Filter: FilterNCSDThuoc,
    Form: FormNCSDTHUOC,
    columns: [
      {
        name: (
          <Tooltip
            placement="top"
            arrow
            TransitionComponent={Zoom}
            title="Mã khoa lâm sàn, cận lâm sàn"
          >
            <span className="two-lines-ellipsis">Mã KLS/CLS</span>
          </Tooltip>
        ),
        width: "120px",
        selector: (row) => row.ma_khoa,
      },
      {
        name: (
          <Tooltip
            placement="top"
            arrow
            TransitionComponent={Zoom}
            title="ID thuốc"
          >
            <span className="two-lines-ellipsis">ID thuốc</span>
          </Tooltip>
        ),
        width: "100px",
        selector: (row) => row.id_thuoc,
      },
      {
        name: (
          <Tooltip
            placement="top"
            arrow
            TransitionComponent={Zoom}
            title="Tên mời thầu (hoạt chất)"
          >
            <span className="two-lines-ellipsis">Tên mời thầu (hoạt chất)</span>
          </Tooltip>
        ),
        width: "200px",
        selector: (row) => row.hoat_chat,
      },
      {
        name: (
          <Tooltip
            placement="top"
            arrow
            TransitionComponent={Zoom}
            title="Nồng độ, hàm lượng"
          >
            <span className="two-lines-ellipsis">Nồng độ, hàm lượng</span>
          </Tooltip>
        ),
        width: "160px",
        selector: (row) => row.ham_luong,
      },
      {
        name: (
          <Tooltip
            placement="top"
            arrow
            TransitionComponent={Zoom}
            title="Dạng bào chế"
          >
            <span className="two-lines-ellipsis">Dạng bào chế</span>
          </Tooltip>
        ),
        width: "130px",
        selector: (row) => row.dang_bao_che,
      },
      {
        name: (
          <Tooltip
            placement="top"
            arrow
            TransitionComponent={Zoom}
            title="Đường dùng"
          >
            <span className="two-lines-ellipsis">Đường dùng</span>
          </Tooltip>
        ),
        width: "120px",
        selector: (row) => row.duong_dung,
      },
      {
        name: (
          <Tooltip
            placement="top"
            arrow
            TransitionComponent={Zoom}
            title="Đơn vị tính"
          >
            <span className="two-lines-ellipsis">ĐVT</span>
          </Tooltip>
        ),
        width: "100px",
        selector: (row) => row.dvt,
      },
      {
        name: (
          <Tooltip
            placement="top"
            arrow
            TransitionComponent={Zoom}
            title="Nhóm"
          >
            <span className="two-lines-ellipsis">Nhóm</span>
          </Tooltip>
        ),
        width: "120px",
        selector: (row) => row.nhom,
      },
      {
        name: (
          <Tooltip
            placement="top"
            arrow
            TransitionComponent={Zoom}
            title="Dự đoán năm tới"
          >
            <span className="two-lines-ellipsis">Dự đoán năm tới</span>
          </Tooltip>
        ),
        width: "150px",
        selector: (row) => row.du_toan,
      },
      {
        name: (
          <Tooltip
            placement="top"
            arrow
            TransitionComponent={Zoom}
            title="Số lượng sử dụng 12 tháng liền kề"
          >
            <span className="two-lines-ellipsis">
              Số lượng sử dụng 12 tháng liền kề
            </span>
          </Tooltip>
        ),
        width: "120px",
        selector: (row) => row.sl_sd_trongnam,
      },
      {
        name: (
          <Tooltip
            placement="top"
            arrow
            TransitionComponent={Zoom}
            title="Đề xuất nhu cầu sử dụng cho năm thứ nhất"
          >
            <span className="two-lines-ellipsis">
              Đề xuất nhu cầu sử dụng cho năm thứ nhất
            </span>
          </Tooltip>
        ),
        width: "120px",
        selector: (row) => row.dx_sd_nam0,
      },
      {
        name: (
          <Tooltip
            placement="top"
            arrow
            TransitionComponent={Zoom}
            title="Tỷ lệ tăng trưởng giữa đề xuất năm thứ nhất và số lượng sử dụng 12 tháng liền kề"
          >
            <span className="two-lines-ellipsis">
              Tỷ lệ tăng trưởng giữa đề xuất năm thứ nhất và số lượng sử dụng 12
              tháng liền kề
            </span>
          </Tooltip>
        ),
        selector: (row) => row.tyle_tt,
      },
      {
        name: (
          <Tooltip
            placement="top"
            arrow
            TransitionComponent={Zoom}
            title="Giải thích lý do vượt 30% số lượng so với 12 tháng liền kề (đề nghị ghi cụ thể số ca dự kiến, chi tiết lý do tăng cao)"
          >
            <span className="two-lines-ellipsis">
              Giải thích lý do vượt 30% số lượng so với 12 tháng liền kề (đề
              nghị ghi cụ thể số ca dự kiến, chi tiết lý do tăng cao)
            </span>
          </Tooltip>
        ),
        width: "200px",
        selector: (row) => row.dien_giai,
      },
      {
        name: (
          <Tooltip
            placement="top"
            arrow
            TransitionComponent={Zoom}
            title="Số lượng tùy chọn mua thêm đề xuất năm thứ nhất (tối đa 30%)"
          >
            <span className="two-lines-ellipsis">
              Số lượng tùy chọn mua thêm đề xuất năm thứ nhất (tối đa 30%)
            </span>
          </Tooltip>
        ),
        width: "120px",
        selector: (row) => row.sl_mua_them_nam0,
      },
      {
        name: (
          <Tooltip
            placement="top"
            arrow
            TransitionComponent={Zoom}
            title="Đề xuất nhu cầu sử dụng cho năm thứ hai (trường hợp thuốc có sự ổn định về mặt sử dụng)"
          >
            <span className="two-lines-ellipsis">
              Đề xuất nhu cầu sử dụng cho năm thứ hai (trường hợp thuốc có sự ổn
              định về mặt sử dụng)
            </span>
          </Tooltip>
        ),
        width: "200px",
        selector: (row) => row.dx_sd_nam1,
      },
      {
        name: (
          <Tooltip
            placement="top"
            arrow
            TransitionComponent={Zoom}
            title="Số lượng tùy chọn mua thêm đề xuất năm thứ hai (tối đa 30%)"
          >
            <span className="two-lines-ellipsis">
              Số lượng tùy chọn mua thêm đề xuất năm thứ hai (tối đa 30%)
            </span>
          </Tooltip>
        ),
        width: "120px",
        selector: (row) => row.sl_mua_them_nam1,
      },
      {
        name: (
          <Tooltip
            placement="top"
            arrow
            TransitionComponent={Zoom}
            title="Thuốc thuộc danh mục thầu tập trung đã dự trù"
          >
            <span className="two-lines-ellipsis">
              Thuốc thuộc danh mục thầu tập trung đã dự trù
            </span>
          </Tooltip>
        ),
        width: "150px",
        selector: (row) => row.dm_thau_dt,
      },
      {
        name: (
          <Tooltip
            placement="top"
            arrow
            TransitionComponent={Zoom}
            title="Tên thuốc đã sử dụng, dự toán"
          >
            <span className="two-lines-ellipsis">
              Tên thuốc đã sử dụng, dự toán
            </span>
          </Tooltip>
        ),
        width: "120px",
        selector: (row) => row.ten_thuoc_da_sd,
      },
      {
        name: (
          <Tooltip
            placement="top"
            arrow
            TransitionComponent={Zoom}
            title="Mã nội bộ của thuốc"
          >
            <span className="two-lines-ellipsis">Mã nội bộ của thuốc</span>
          </Tooltip>
        ),
        width: "120px",
        selector: (row) => row.ma_noi_bo,
      },
      {
        name: (
          <Tooltip
            placement="top"
            arrow
            TransitionComponent={Zoom}
            title="Giá mua sắm gần nhất tại BVCR"
          >
            <span className="two-lines-ellipsis">
              Giá mua sắm gần nhất tại BVCR
            </span>
          </Tooltip>
        ),
        width: "120px",
        selector: (row) => row.gia_gan_nhat,
      },
      {
        name: (
          <Tooltip
            placement="top"
            arrow
            TransitionComponent={Zoom}
            title="Hệ thuốc"
          >
            <span className="two-lines-ellipsis">Hệ thuốc</span>
          </Tooltip>
        ),
        width: "120px",
        selector: (row) => row.he_thuoc,
      },
      {
        name: (
          <Tooltip
            placement="top"
            arrow
            TransitionComponent={Zoom}
            title="Mã ánh xạ bảo hiểm"
          >
            <span className="two-lines-ellipsis">Mã ánh xạ bảo hiểm</span>
          </Tooltip>
        ),
        width: "120px",
        selector: (row) => row.ma_anh_xa,
      },
      {
        name: (
          <Tooltip
            placement="top"
            arrow
            TransitionComponent={Zoom}
            title="Ghi chú"
          >
            <span className="two-lines-ellipsis">Ghi chú</span>
          </Tooltip>
        ),
        width: "200px",
        selector: (row) => row.note,
      },
    ],
  },
  dtthuoc: {
    title: "Dự trù thuốc",
    apiCode: "dtthuoc",
    allowCreate: true,
    showOptions: true,
    showActions: true,
    selectableRows: true,
    allowFilter: true,
    stringifyData: true,
    Filter: FilterDTThuoc,
    Form: FormDTTHUOC,
    columns: [
      {
        name: (
          <Tooltip
            placement="top"
            arrow
            TransitionComponent={Zoom}
            title="Mã khoa lâm sàn, cận lâm sàn"
          >
            <span className="two-lines-ellipsis">Mã KLS/CLS</span>
          </Tooltip>
        ),
        width: "120px",
        selector: (row) => row.ma_khoa,
      },
      {
        name: (
          <Tooltip
            placement="top"
            arrow
            TransitionComponent={Zoom}
            title="Số thứ tự"
          >
            <span className="two-lines-ellipsis">STT</span>
          </Tooltip>
        ),
        width: "80px",
        selector: (row) => row.stt,
      },
      {
        name: (
          <Tooltip
            arrow
            placement="top"
            TransitionComponent={Zoom}
            title="Số thứ tự"
          >
            <span className="two-lines-ellipsis">STT</span>
          </Tooltip>
        ),
        width: "80px",
        selector: (row) => row.stt,
      },
      {
        name: (
          <Tooltip
            arrow
            placement="top"
            TransitionComponent={Zoom}
            title="Tên hoạt chất"
          >
            <span className="two-lines-ellipsis">Tên hoạt chất </span>
          </Tooltip>
        ),
        width: "150px",
        selector: (row) => row.hoat_chat,
      },
      {
        name: (
          <Tooltip
            arrow
            placement="top"
            TransitionComponent={Zoom}
            title="Tên thương mại (nếu có)"
          >
            <span className="two-lines-ellipsis">Tên thương mại</span>
          </Tooltip>
        ),
        width: "150px",
        selector: (row) => row.ten_thuong_mai,
      },
      {
        name: (
          <Tooltip
            arrow
            placement="top"
            TransitionComponent={Zoom}
            title="Nồng độ, hàm lượng"
          >
            <span className="two-lines-ellipsis">Nồng độ, hàm lượng</span>
          </Tooltip>
        ),
        width: "160px",
        selector: (row) => row.ham_luong,
      },
      {
        name: (
          <Tooltip
            arrow
            placement="top"
            TransitionComponent={Zoom}
            title="Dạng bào chế"
          >
            <span className="two-lines-ellipsis">Dạng bào chế</span>
          </Tooltip>
        ),
        width: "150px",
        selector: (row) => row.dang_bao_che,
      },
      {
        name: (
          <Tooltip
            arrow
            placement="top"
            TransitionComponent={Zoom}
            title="Đường dùng"
          >
            <span className="two-lines-ellipsis">Đường dùng</span>
          </Tooltip>
        ),
        width: "150px",
        selector: (row) => row.duong_dung,
      },
      {
        name: (
          <Tooltip
            arrow
            placement="top"
            TransitionComponent={Zoom}
            title="Nhóm"
          >
            <span className="two-lines-ellipsis">Nhóm</span>
          </Tooltip>
        ),
        width: "120px",
        selector: (row) => row.nhom,
      },
      {
        name: (
          <Tooltip
            arrow
            placement="top"
            TransitionComponent={Zoom}
            title="Đơn vị tính"
          >
            <span className="two-lines-ellipsis">ĐVT</span>
          </Tooltip>
        ),
        width: "120px",
        selector: (row) => row.nhom,
      },
      {
        name: (
          <Tooltip
            arrow
            placement="top"
            TransitionComponent={Zoom}
            title="Số lượng dự trù"
          >
            <span className="two-lines-ellipsis">Số lượng dự trù</span>
          </Tooltip>
        ),
        width: "150px",
        selector: (row) => row.sl_dutru,
      },
      {
        name: (
          <Tooltip
            arrow
            placement="top"
            TransitionComponent={Zoom}
            title="Nhà sản xuất (nếu có thông tin)"
          >
            <span className="two-lines-ellipsis">Nhà sản xuất</span>
          </Tooltip>
        ),
        width: "150px",
        selector: (row) => row.nsx,
      },
      {
        name: (
          <Tooltip
            arrow
            placement="top"
            TransitionComponent={Zoom}
            title="Nhà cung cấp (nếu có thông tin)"
          >
            <span className="two-lines-ellipsis">Nhà cung cấp</span>
          </Tooltip>
        ),
        width: "150px",
        selector: (row) => row.ncc,
      },
      {
        name: (
          <Tooltip
            arrow
            placement="top"
            TransitionComponent={Zoom}
            title="Lý do dự trù"
          >
            <span className="two-lines-ellipsis">Lý do dự trù</span>
          </Tooltip>
        ),
        width: "200px",
        selector: (row) => row.ly_do,
      },
      {
        name: (
          <Tooltip
            arrow
            placement="top"
            TransitionComponent={Zoom}
            title="ID thuốc"
          >
            <span className="two-lines-ellipsis">ID thuốc</span>
          </Tooltip>
        ),
        width: "120px",
        selector: (row) => row.id_thuoc,
      },
    ],
  },
  cr_vtyt: {
    title: "Vật tư y tế",
    apiCode: "cr_vtyt",
    allowCreate: false,
    showOptions: true,
    showActions: true,
    selectableRows: true,
    allowFilter: true,
    stringifyData: true,
    fields: [
      { label: "Tên thiết bị", value: "ten_vtyt" },
      { label: "Đơn vị tính", value: "dvt" },
      // { label: "Khối lượng", value: "soluong" },
      { label: "Xuất xứ", value: "xuatxu" },
      { label: "Nhãn hiệu", value: "nhanhieu" },
      { label: "Ký mã hiệu", value: "kyhieu" },
      { label: "Hãng sản xuất", value: "hsx" },
      // { label: "Mã hồ sơ", value: "mahs" },
      // { label: "Chủng loại", value: "model" },
      // { label: "Số lưu hành", value: "soluuhanh" },
      // { label: "Cấu hình kỹ thuật", value: "cauhinhkythuat" },
      { label: "Đơn giá", value: "dongia" },
      { label: "Mã TBMT", value: "tbmt" },
      // { label: "Tên CĐT", value: "cdt" },
      // { label: "Ngày đăng tải KQLCNT", value: "ngay_kqlcnt" },
      // { label: "Số quyết định", value: "sqd" },
      // { label: "Địa điểm", value: "diadiem" },
    ],
    fastFields: [
      { label: "Tên thiết bị", value: "ten_vtyt" },
      { label: "Đơn vị tính", value: "dvt" },
      { label: "Xuất xứ", value: "xuatxu" },
      { label: "Nhãn hiệu", value: "nhanhieu" },
      { label: "Ký mã hiệu", value: "kyhieu" },
      { label: "Hãng sản xuất", value: "hsx" },
      { label: "Mã hồ sơ", value: "mahs" },
      { label: "Chủng loại", value: "model" },
      { label: "Số lưu hành", value: "soluuhanh" },
      { label: "Cấu hình kỹ thuật", value: "cauhinhkythuat" },
      { label: "Mã TBMT", value: "tbmt" },
      { label: "Tên CĐT", value: "cdt" },
      { label: "Số quyết định", value: "sqd" },
      { label: "Địa điểm", value: "diadiem" },
    ],
    Form: FormCRVTYT,
    Filter: FilterCRVTYT,
    columns: [
      {
        name: "ID (BV)",
        width: "120px",
        reorder: true,
        selector: (row) => row.id,
      },
      {
        name: "Tên thiết bị",
        width: "200px",
        reorder: true,
        selector: (row) => row.ten_vtyt,
      },
      {
        name: "ĐVT",
        width: "120px",
        reorder: true,
        selector: (row) => row.dvt,
      },
      {
        name: "Khối lượng",
        width: "130px",
        reorder: true,
        right: true,
        selector: (row) => row.soluong,
      },
      {
        name: "Đơn giá",
        width: "120px",
        reorder: true,
        right: true,
        selector: (row) => row.dongia,
        format: (row) => numeralCustom(row.dongia).format(),
      },
      {
        name: "Xuất xứ",
        width: "120px",
        reorder: true,
        selector: (row) => row.xuatxu,
      },
      {
        name: "Nhãn hiệu",
        width: "130px",
        reorder: true,
        selector: (row) => row.nhanhieu,
      },
      {
        name: "Ký mã hiệu",
        width: "140px",
        reorder: true,
        selector: (row) => row.kyhieu,
      },
      {
        name: "Hãng SX",
        width: "140px",
        reorder: true,
        selector: (row) => row.hsx,
      },
      {
        name: "Mã hồ sơ",
        width: "120px",
        reorder: true,
        selector: (row) => row.mahs,
      },
      {
        name: "Chủng loại",
        width: "140px",
        reorder: true,
        selector: (row) => row.model,
      },
      {
        name: "Số lưu hành",
        width: "140px",
        reorder: true,
        selector: (row) => row.soluuhanh,
      },
      {
        name: "Năm sản xuất",
        width: "150px",
        reorder: true,
        selector: (row) => row.namsx,
        format: (row) => formatDateDisplay(row.namsx, "DD/MM/YYYY"),
      },
      {
        name: "Cấu hình",
        width: "120px",
        reorder: true,
        selector: (row) => row.cauhinhkythuat,
      },
      {
        name: "Mã TBMT",
        width: "120px",
        reorder: true,
        selector: (row) => row.tbmt,
      },
      {
        name: "Tên CĐT",
        width: "120px",
        reorder: true,
        selector: (row) => row.cdt,
      },
      {
        name: "Ngày đăng tải KQLCNT",
        width: "220px",
        reorder: true,
        selector: (row) => row.ngay_kqlcnt,
        format: (row) => formatDateDisplay(row.ngay_kqlcnt, "DD/MM/YYYY"),
      },
      {
        name: "Số QĐ",
        width: "140px",
        reorder: true,
        selector: (row) => row.sqd,
      },
      {
        name: "Nội dung QĐ",
        width: "200px",
        selector: (row) => row.ndqd,
      },
      {
        name: "Ngày ban hành QĐ",
        width: "200px",
        reorder: true,
        selector: (row) => row.ngayqd,
        format: (row) => formatDateDisplay(row.ngayqd, "DD/MM/YYYY"),
      },
      {
        name: "Nhà thầu tham dự",
        width: "200px",
        reorder: true,
        selector: (row) => row.slnhathau,
      },
      {
        name: "Địa điểm",
        width: "150px",
        reorder: true,
        selector: (row) => row.diadiem,
      },
    ],
  },
  cr_hc: {
    title: "Hóa chất",
    apiCode: "cr_hc",
    allowCreate: false,
    showOptions: true,
    showActions: true,
    selectableRows: true,
    allowFilter: true,
    stringifyData: true,
    fields: [
      { label: "Tên hóa chất", value: "ten_hc" },
      { label: "Đơn vị tính", value: "dvt" },
      { label: "Khối lượng", value: "soluong" },
      { label: "Xuất xứ", value: "xuatxu" },
      { label: "Nhãn hiệu", value: "nhanhieu" },
      { label: "Ký mã hiệu", value: "kyhieu" },
      { label: "Hãng sản xuất", value: "hsx" },
      { label: "Mã hồ sơ", value: "mahs" },
      { label: "Chủng loại", value: "model" },
      { label: "Số lưu hành", value: "soluuhanh" },
      { label: "Cấu hình kỹ thuật", value: "cauhinhkythuat" },
      { label: "Đơn giá", value: "dongia" },
      { label: "Mã TBMT", value: "tbmt" },
      { label: "Tên CĐT", value: "cdt" },
      { label: "Ngày đăng tải KQLCNT", value: "ngay_kqlcnt" },
      { label: "Số quyết định", value: "sqd" },
      { label: "Địa điểm", value: "diadiem" },
    ],
    fastFields: [
      { label: "Tên hóa chất", value: "ten_hc" },
      { label: "Đơn vị tính", value: "dvt" },
      { label: "Xuất xứ", value: "xuatxu" },
      { label: "Nhãn hiệu", value: "nhanhieu" },
      { label: "Ký mã hiệu", value: "kyhieu" },
      { label: "Hãng sản xuất", value: "hsx" },
      { label: "Mã hồ sơ", value: "mahs" },
      { label: "Chủng loại", value: "model" },
      { label: "Số lưu hành", value: "soluuhanh" },
      { label: "Cấu hình kỹ thuật", value: "cauhinhkythuat" },
      { label: "Mã TBMT", value: "tbmt" },
      { label: "Tên CĐT", value: "cdt" },
      { label: "Số quyết định", value: "sqd" },
      { label: "Địa điểm", value: "diadiem" },
    ],
    Filter: FilterCRHC,
    columns: [
      {
        name: "Tên hóa chất",
        width: "200px",
        reorder: true,
        selector: (row) => row.ten_hc,
      },
      {
        name: "ĐVT",
        width: "80px",
        reorder: true,
        selector: (row) => row.dvt,
      },
      {
        name: "Khối lượng",
        width: "140px",
        reorder: true,
        right: true,
        selector: (row) => row.soluong,
        format: (row) => numeralCustom(row.soluong).format(),
      },
      {
        name: "Đơn giá",
        width: "120px",
        reorder: true,
        right: true,
        selector: (row) => row.dongia,
        format: (row) => numeralCustom(row.dongia).format(),
      },
      {
        name: "Xuất xứ",
        width: "150px",
        reorder: true,
        selector: (row) => row.xuatxu,
      },
      {
        name: "Nhãn hiệu",
        width: "150px",
        reorder: true,
        selector: (row) => row.nhanhieu,
      },
      {
        name: "Ký mã hiệu",
        width: "150px",
        reorder: true,
        selector: (row) => row.kyhieu,
      },
      {
        name: "Hãng sản xuất",
        width: "150px",
        reorder: true,
        selector: (row) => row.hsx,
      },
      {
        name: "Mã hồ sơ",
        width: "120px",
        reorder: true,
        selector: (row) => row.mahs,
      },
      {
        name: "Chủng loại",
        width: "140px",
        reorder: true,
        selector: (row) => row.model,
      },
      {
        name: "Số lưu hành",
        width: "140px",
        reorder: true,
        selector: (row) => row.soluuhanh,
      },
      {
        name: "Năm sản xuất",
        width: "150px",
        reorder: true,
        selector: (row) => row.namsx,
        format: (row) => formatDateDisplay(row.namsx, "DD/MM/YYYY"),
      },
      {
        name: "Cấu hình",
        width: "200px",
        reorder: true,
        selector: (row) => row.cauhinhkythuat,
      },
      {
        name: "Mã TBMT",
        width: "120px",
        reorder: true,
        selector: (row) => row.tbmt,
      },
      {
        name: "Tên CĐT",
        width: "150px",
        reorder: true,
        selector: (row) => row.cdt,
      },
      {
        name: "Ngày đăng tải KQLCNT",
        width: "220px",
        reorder: true,
        selector: (row) => row.ngay_kqlcnt,
        format: (row) => formatDateDisplay(row.ngay_kqlcnt, "DD/MM/YYYY"),
      },
      {
        name: "Số QĐ",
        width: "120px",
        reorder: true,
        selector: (row) => row.sqd,
      },
      {
        name: "Ngày ban hành QĐ",
        width: "200px",
        reorder: true,
        selector: (row) => row.ngayqd,
        format: (row) => formatDateDisplay(row.ngayqd, "DD/MM/YYYY"),
      },
      {
        name: "Số nhà thầu tham dự",
        width: "200px",
        reorder: true,
        selector: (row) => row.slnhathau,
      },
      {
        name: "Địa điểm",
        width: "200px",
        reorder: true,
        selector: (row) => row.diadiem,
      },
    ],
  },
  fos_rpkeysearch: {
    title: "BC kết quả tìm kiếm",
    apiCode: "fos_rpkeysearch2",
    showExportExcel: true,
    showOptions: false,
    showActions: false,
    selectableRows: false,
    allowFilter: true,
    stringifyData: false,
    outerQuery: true,
    paginationText: true,
    filenameExport: "BAO_CAO_KET_QUA_TIM_KIEM.xlsx",
    Filter: FilterRPKEYSEARCH,
    renderInnerTop: ({ data }) => {
      const ids = (data || []).map((item) => item.key);
      return (
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="space-between"
          sx={{ flex: 1 }}
        >
          <Stack
            direction="row"
            alignItems="center"
            justifyContent="center"
            gap={2}
            sx={{ flex: 1 }}
          >
            {/* Max */}
            <Stack direction="row" gap={1}>
              <Box
                sx={{
                  width: "20px",
                  height: "20px",
                  backgroundColor: COLORS.max,
                }}
              ></Box>
              <Typography>Cao nhất</Typography>
            </Stack>
            {/* Min */}
            <Stack direction="row" gap={1}>
              <Box
                sx={{
                  width: "20px",
                  height: "20px",
                  backgroundColor: COLORS.min,
                }}
              ></Box>
              <Typography>Nhỏ nhất</Typography>
            </Stack>
            {/* Near */}
            <Stack direction="row" gap={1}>
              <Box
                sx={{
                  width: "20px",
                  height: "20px",
                  backgroundColor: COLORS.near,
                }}
              ></Box>
              <Typography>Gần nhất</Typography>
            </Stack>
          </Stack>
          <Stack direction="row" alignItems="center" gap={1} sx={{ pr: 1 }}>
            <ExportToExcelButton
              apiCode="cr_thuoc"
              query={{
                q: {
                  id: { $in: ids },
                },
              }}
              renderDisplay={({ openModal }) => {
                return (
                  <Button
                    onClick={openModal}
                    variant="contained"
                    size="small"
                    sx={{
                      textTransform: "none",
                      color: "common.white",
                      boxShadow: "none",
                      "&:hover": { boxShadow: "none" },
                    }}
                  >
                    Xuất chi tiết
                  </Button>
                );
              }}
            />
          </Stack>
        </Stack>
      );
    },
    columns: [
      {
        name: "",
        width: "120px",
        cell: (row) => {
          return (
            <Stack
              direction="row"
              alignItems="center"
              justifyContent="center"
              sx={{ width: "100%" }}
            >
              <ModalDetailId
                group={{
                  ...groups.cr_thuoc,
                  title: `Chi tiết theo id '${
                    row.max_id || row.min_id || row.near_id
                  }'`,
                  allowFilter: false,
                  showExclued: true,
                  condition: { id: row.max_id || row.min_id || row.near_id },
                }}
              />
              <ExportToExcelButton
                apiCode="cr_thuoc"
                query={{ q: { id: row.key } }}
                filenameExport={``}
              />
              <DeleteGroupButton row={row} apiCode="cr_thuoc" />
            </Stack>
          );
        },
      },
      ...cols,
    ],
  },
  fos_rpdtthuoc: {
    title: "BC dự trù toàn bệnh viện",
    apiCode: "fos_rpdtthuoc",
    showExportExcel: true,
    showOptions: false,
    showActions: false,
    selectableRows: false,
    allowFilter: false,
    stringifyData: true,
    columns: [
      {
        name: (
          <Tooltip
            placement="top"
            arrow
            TransitionComponent={Zoom}
            title="ID thuốc"
          >
            <span className="two-lines-ellipsis">ID thuốc</span>
          </Tooltip>
        ),
        width: "120px",
        selector: (row) => row.id_thuoc,
      },
      {
        name: (
          <Tooltip
            placement="top"
            arrow
            TransitionComponent={Zoom}
            title="Tên mời thầu (hoạt chất)"
          >
            <span className="two-lines-ellipsis">Tên mời thầu (hoạt chất)</span>
          </Tooltip>
        ),
        width: "200px",
        selector: (row) => row.hoat_chat,
      },
      {
        name: (
          <Tooltip
            placement="top"
            arrow
            TransitionComponent={Zoom}
            title="Nồng độ, hàm lượng"
          >
            <span className="two-lines-ellipsis">Nồng độ, hàm lượng</span>
          </Tooltip>
        ),
        width: "160px",
        selector: (row) => row.ham_luong,
      },
      {
        name: (
          <Tooltip
            placement="top"
            arrow
            TransitionComponent={Zoom}
            title="Dạng bào chế"
          >
            <span className="two-lines-ellipsis">Dạng bào chế</span>
          </Tooltip>
        ),
        width: "130px",
        selector: (row) => row.dang_bao_che,
      },
      {
        name: (
          <Tooltip
            placement="top"
            arrow
            TransitionComponent={Zoom}
            title="Đường dùng"
          >
            <span className="two-lines-ellipsis">Đường dùng</span>
          </Tooltip>
        ),
        width: "130px",
        selector: (row) => row.duong_dung,
      },
      {
        name: (
          <Tooltip
            placement="top"
            arrow
            TransitionComponent={Zoom}
            title="Đơn vị tính"
          >
            <span className="two-lines-ellipsis">ĐVT</span>
          </Tooltip>
        ),
        width: "120px",
        selector: (row) => row.dvt,
      },
      {
        name: (
          <Tooltip
            placement="top"
            arrow
            TransitionComponent={Zoom}
            title="Nhóm"
          >
            <span className="two-lines-ellipsis">Nhóm</span>
          </Tooltip>
        ),
        width: "120px",
        selector: (row) => row.nhom,
      },
      {
        name: (
          <Tooltip
            placement="top"
            arrow
            TransitionComponent={Zoom}
            title="Dự toán năm tới (khoa đã dự trụ)"
          >
            <span className="two-lines-ellipsis">Dự toán năm tới</span>
          </Tooltip>
        ),
        width: "150px",
        selector: (row) => row.du_toan,
      },
      {
        name: (
          <Tooltip
            placement="top"
            arrow
            TransitionComponent={Zoom}
            title="Số lượng sử dụng 12 tháng liền kề"
          >
            <span className="two-lines-ellipsis">
              Số lượng sử dụng 12 tháng liền kề
            </span>
          </Tooltip>
        ),
        width: "150px",
        selector: (row) => row.sl_sd_trongnam,
      },
      {
        name: (
          <Tooltip
            placement="top"
            arrow
            TransitionComponent={Zoom}
            title="Đề xuất nhu cầu sử dụng cho năm thứ nhất"
          >
            <span className="two-lines-ellipsis">
              Đề xuất nhu cầu sử dụng cho năm thứ nhất
            </span>
          </Tooltip>
        ),
        width: "150px",
        selector: (row) => row.dx_sd_nam0,
      },
      {
        name: (
          <Tooltip
            placement="top"
            arrow
            TransitionComponent={Zoom}
            title="Tỷ lệ tăng trưởng giữa đề xuất năm thứ nhất và số lượng sử dụng 12 tháng liền kề"
          >
            <span className="two-lines-ellipsis">
              Tỷ lệ tăng trưởng giữa đề xuất năm thứ nhất và số lượng sử dụng 12
              tháng liền kề
            </span>
          </Tooltip>
        ),
        width: "150px",
        selector: (row) => row.ty_le,
      },
      {
        name: (
          <Tooltip
            placement="top"
            arrow
            TransitionComponent={Zoom}
            title="Tỷ lệ tăng trưởng giữa đề xuất năm thứ nhất và số lượng sử dụng 12 tháng liền kề"
          >
            <span className="two-lines-ellipsis">
              Tỷ lệ tăng trưởng giữa đề xuất năm thứ nhất và số lượng sử dụng 12
              tháng liền kề
            </span>
          </Tooltip>
        ),
        width: "150px",
        selector: (row) => row.ty_le,
      },
      {
        name: (
          <Tooltip
            placement="top"
            arrow
            TransitionComponent={Zoom}
            title="Giải thích lý do vượt 30% số lượng so với 12 tháng liền kề (đề nghị ghi cụ thể số ca dự kiến, chi tiết lý do tăng cao)"
          >
            <span className="two-lines-ellipsis">
              Giải thích lý do vượt 30% số lượng so với 12 tháng liền kề (đề
              nghị ghi cụ thể số ca dự kiến, chi tiết lý do tăng cao)
            </span>
          </Tooltip>
        ),
        width: "150px",
        selector: (row) => row.dien_giai,
      },
      {
        name: (
          <Tooltip
            placement="top"
            arrow
            TransitionComponent={Zoom}
            title="Số lượng tùy chọn mua thêm đề xuất năm thứ nhất (tối đa 30%)"
          >
            <span className="two-lines-ellipsis">
              Số lượng tùy chọn mua thêm đề xuất năm thứ nhất (tối đa 30%)
            </span>
          </Tooltip>
        ),
        width: "150px",
        selector: (row) => row.sl_mua_them_nam0,
      },
      {
        name: (
          <Tooltip
            placement="top"
            arrow
            TransitionComponent={Zoom}
            title="Đề xuất nhu cầu sử dụng cho năm thứ hai (trường hợp thuốc có sự ổn định về mặt sử dụng)"
          >
            <span className="two-lines-ellipsis">
              Đề xuất nhu cầu sử dụng cho năm thứ hai (trường hợp thuốc có sự ổn
              định về mặt sử dụng)
            </span>
          </Tooltip>
        ),
        width: "150px",
        selector: (row) => row.dx_sd_nam1,
      },
      {
        name: (
          <Tooltip
            placement="top"
            arrow
            TransitionComponent={Zoom}
            title="Số lượng tùy chọn mua thêm đề xuất năm thứ hai (tối đa 30%)"
          >
            <span className="two-lines-ellipsis">
              Số lượng tùy chọn mua thêm đề xuất năm thứ hai (tối đa 30%)
            </span>
          </Tooltip>
        ),
        width: "150px",
        selector: (row) => row.sl_mua_them_nam1,
      },
      {
        name: (
          <Tooltip
            placement="top"
            arrow
            TransitionComponent={Zoom}
            title="Thuốc thuộc danh mục thầu tập trung đã dự trù"
          >
            <span className="two-lines-ellipsis">
              Thuốc thuộc danh mục thầu tập trung đã dự trù
            </span>
          </Tooltip>
        ),
        width: "150px",
        selector: (row) => row.dm_thau_dt,
      },
      {
        name: (
          <Tooltip
            placement="top"
            arrow
            TransitionComponent={Zoom}
            title="Tên thuốc đã sử dụng, dự toán"
          >
            <span className="two-lines-ellipsis">
              Tên thuốc đã sử dụng, dự toán
            </span>
          </Tooltip>
        ),
        width: "150px",
        selector: (row) => row.ten_thuoc_da_sd,
      },
      {
        name: (
          <Tooltip
            placement="top"
            arrow
            TransitionComponent={Zoom}
            title="Giá mua sắm gần nhất tại BVCR"
          >
            <span className="two-lines-ellipsis">
              Giá mua sắm gần nhất tại BVCR
            </span>
          </Tooltip>
        ),
        width: "150px",
        selector: (row) => row.gia_gan_nhat,
        format: (row) => numeralCustom(row.gia_gan_nhat).format(),
      },
      {
        name: (
          <Tooltip
            placement="top"
            arrow
            TransitionComponent={Zoom}
            title="Hệ thuốc"
          >
            <span className="two-lines-ellipsis">Hệ thuốc</span>
          </Tooltip>
        ),
        width: "150px",
        selector: (row) => row.he_thuoc,
      },
      {
        name: (
          <Tooltip
            placement="top"
            arrow
            TransitionComponent={Zoom}
            title="Mã ánh xạ bảo hiểm"
          >
            <span className="two-lines-ellipsis">Mã ánh xạ bảo hiểm</span>
          </Tooltip>
        ),
        width: "120px",
        selector: (row) => row.ma_anh_xa,
      },
      {
        name: (
          <Tooltip
            placement="top"
            arrow
            TransitionComponent={Zoom}
            title="Giá bình quân sử dụng 12 tháng liền kề"
          >
            <span className="two-lines-ellipsis">
              Giá bình quân sử dụng 12 tháng liền kề
            </span>
          </Tooltip>
        ),
        width: "150px",
        selector: (row) => row.gia_trung_binh,
        format: (row) => numeralCustom(row.gia_trung_binh).format(),
      },
      {
        name: (
          <Tooltip
            placement="top"
            arrow
            TransitionComponent={Zoom}
            title="Ghi chú"
          >
            <span className="two-lines-ellipsis">Ghi chú</span>
          </Tooltip>
        ),
        width: "150px",
        selector: (row) => row.note,
      },
    ],
  },
  participant: {
    apiCode: "participant",
    title: "Người dùng",
    allowCreate: true,
    allowFilter: true,
    fields: [],
    showActions: true,
    showOptions: true,
    selectableRows: true,
    stringifyData: true,
    Form: FormParticipant,
    Filter: FilterParticipant,
    columns: [
      {
        name: "Tài khoản",
        width: "200px",
        wrap: true,
        selector: (row) => row.email,
      },
      {
        name: "Tên",
        width: "200px",
        wrap: true,
        selector: (row) => row.name,
      },
      {
        name: "Nhóm",
        width: "140px",
        wrap: true,
        selector: (row) => row.group_name,
      },
      {
        name: "Quản trị viên",
        width: "130px",
        wrap: true,
        selector: (row) => row.admin,
        cell: (row) => {
          return (
            <CheckboxUpdate
              idUpdate={row?._id}
              defaultChecked={row?.admin}
              apiCode="participant"
              emailCheckSelf={row?.email}
              fieldUpdate="admin"
            />
          );
        },
      },
      {
        name: "",
        width: "150px",
        cell: (row) => {
          return <ResetPassword email={row.email} />;
        },
      },
    ],
  },
  usergroup: {
    apiCode: "usergroup",
    title: "Nhóm người dùng",
    fields: [{ value: "group_name", label: "Tên nhóm" }],
    allowCreate: true,
    allowFilter: true,
    selectableRows: true,
    showActions: true,
    showOptions: true,
    stringifyData: true,
    Expand: ExpandUsergroup,
    Form: FormUsergroup,
    Filter: FilterUsergroup,
    columns: [
      {
        name: "Tên nhóm",
        width: "200px",
        wrap: true,
        selector: (row) => row.group_name,
      },
    ],
  },
};

export { categories };
